export const compareStrings = (numericOrder: number, a?: string, b?: string) => {
  if (!a && !b) return 0
  if (!a) return -1 * numericOrder
  if (!b) return 1 * numericOrder
  return a.localeCompare(b) * numericOrder
}
